import Container from '@/components/Container';
import MarketingSection from './MarketingSection';

export default function MarketingHighlightCopy({
  children,
}) {
  return (
    <MarketingSection spacing="py-10 lg:py-20" className="bg-gray-900">
      <Container maxWidth="max-w-screen-lg">
        <div className="text-gray-400 text-xl lg:text-2xl lg:font-light text-center lg:pr-20">
          {children}
        </div>
      </Container>
    </MarketingSection>
  );
}
